module.exports = __webpack_public_path__ + "img/card1.3bb4c55a.png";